import apiClient from './client';
import { User } from '@/types';

export interface UserListParams {
  page?: number;
  limit?: number;
  search?: string;
  role?: string;
}

export interface UserListResponse {
  data: User[];
  total: number;
  page: number;
  limit: number;
}

export interface Role {
  value: string;
  label: string;
  description: string;
}

export interface CreateUserData {
  username: string;
  email: string;
  password: string;
  roles: string[];
  isActive: boolean;
}

export interface UpdateUserData {
  username?: string;
  email?: string;
  password?: string;
  roles?: string[];
  isActive?: boolean;
}

export const usersApi = {
  getAll: async (params: UserListParams = {}): Promise<UserListResponse> => {
    const response = await apiClient.get('/api/users', { params });
    return response.data;
  },

  getById: async (id: string): Promise<User> => {
    const response = await apiClient.get(`/api/users/${id}`);
    return response.data;
  },

  create: async (data: CreateUserData): Promise<{ message: string }> => {
    const response = await apiClient.post('/api/users', data);
    return response.data;
  },

  update: async (id: string, data: UpdateUserData): Promise<{ message: string }> => {
    const response = await apiClient.put(`/api/users/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<{ message: string }> => {
    const response = await apiClient.delete(`/api/users/${id}`);
    return response.data;
  },

  toggleActive: async (id: string): Promise<{ message: string }> => {
    const response = await apiClient.patch(`/api/users/${id}/toggle-active`);
    return response.data;
  },

  getRoles: async (): Promise<{ data: Role[] }> => {
    const response = await apiClient.get('/api/users/roles/list');
    return response.data;
  },
};
